import { render, staticRenderFns } from "./RunningMedicalExamination.vue?vue&type=template&id=462c7782&"
import script from "./RunningMedicalExamination.vue?vue&type=script&lang=js&"
export * from "./RunningMedicalExamination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports